import { useRef } from "react"
import {Link} from "react-router-dom"
import Logo from "./logo"
import { ArrowRight, Check } from "lucide-react"
import KeyFeatures from "./keyfeatures"
import BenefitsTabs from "./benefits-tabs"
import FAQTabs from "./faq-accordion"
import { useAuth } from "../contexts/auth-context"
import { useNavigate } from "react-router-dom"
import { useToast } from "../components/ui/use-toast"
import TermsandConditions from "./term-comdition"
import PrivacyPolicy from "./privacy-policy"

export default function PatientCareLanding() {
  const abhaBenefitsRef = useRef<HTMLDivElement>(null)
  const { mobile } = useAuth() // Get mobile from auth context
  const navigate = useNavigate() // For navigation
  const { toast } = useToast() // For toast notifications

  // Handler for Book Appointment button
  const handleBookAppointment = () => {
    const storedMobile = localStorage.getItem("mobile");
    
    if (storedMobile) {
      // Mobile exists in localStorage, redirect to /doctors
      navigate("/doctors");
    } else {
      navigate("/doctors-list");
    }
  };

  return (
    <div className="antialiased text-gray-800 min-h-screen flex flex-col">
      {/* Navigation Bar */}
      <nav className="sticky top-0 z-10 flex w-full items-center justify-between px-6 py-3 border-b bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="flex items-center">
          <Logo />
        </div>
        <button
          onClick={() => window.open(`${process.env.REACT_APP_CREATE_ABHA_URL}/app/abha`, "_blank")}
          className="py-2 px-5  bg-white border border-[#008080] hover:bg-gray-50 text-[#008080] font-medium rounded-full transition-all duration-300 transform hover:scale-105 flex items-center gap-2 shadow-sm hover:shadow-md"
        >
          <span>Create ABHA</span>
          <ArrowRight className="w-4 h-4" />
        </button>
      </nav>

      {/* Hero Section */}
      <section className="pt-8 md:pt-7 pb-16 md:pb-24 bg-gradient-to-br from-green-50 to-white overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center">
            {/* Left column: Text content */}
            <div className="w-full lg:w-1/2 lg:pr-12 mb-10 lg:mb-0">
              <span className="inline-block px-5 py-2 bg-gradient-to-r from-[#e6fffa] to-[#b2f5ea] text-[#008080] rounded-full text-sm font-medium font-roboto mb-6 shadow-lg border border-[#99f6e4] hover:shadow-xl hover:-translate-y-0.5 transform transition-all duration-300">
                Your Health, Your Control
              </span>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#008080] mb-6 leading-tight font-nunito">
                Your Health Journey, Simplified
              </h1>
              <p className="text-lg md:text-xl text-gray-700 mb-8 font-roboto leading-relaxed">
                Access your medical records, book appointments, and manage your family's health all in one secure
                platform.
              </p>

              {/* CTA button */}
              <div className="max-w-md w-full">
                {/* <div className="flex flex-col space-y-4">
                  <button 
                  onClick={handleBookAppointment}
                  className="w-full bg-[#008080] hover:bg-[#006666] text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-[#008080] focus:ring-opacity-50 font-roboto shadow-md hover:shadow-lg flex items-center justify-center gap-2">
                    <span>Book Appointment Now!</span>
                    <ArrowRight className="w-4 h-4" />
                  </button>
                  <div className="max-w-md w-full"> */}
                <div className="flex flex-col space-y-4">
                  <button
                    onClick={handleBookAppointment}
                    className="w-full bg-[#008080] hover:bg-[#006666] text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-[#008080] focus:ring-opacity-50 font-roboto shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                  >
                    <span>Book Appointment Now!</span>
                    <ArrowRight className="w-4 h-4" />
                  </button>
                  <div className="mb-5 mt-5 text-xs text-gray-600">
                    By continuing, you agree to&nbsp;
                    <Link to="/terms-and-conditions" className="text-teal-600 underline hover:text-teal-800 transition-colors font-medium">
  T&C
</Link>
                    &nbsp;and{' '}
                    <Link to="/privacy-policy" className="text-teal-600 underline hover:text-teal-800 transition-colors font-medium">
  Privacy Policy
</Link>
                    {/* &nbsp;and{' '}
                    <a
                      //href={`${process.env.REACT_APP_API_BASE_URL}/user-agreement`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-teal-600 underline hover:text-teal-800 transition-colors font-medium"
                    >
                      User Agreement
                    </a> */}
                    .
                  </div>
                </div>
              </div>
              {/* </div> */}
              {/* </div> */}

              {/* Trust badges */}
              <div className="flex flex-wrap mt-8">
      <div className="flex items-center mr-6 mb-4">
        <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
          <Check className="h-4 w-4 text-green-500" />
        </div>
        <span className="ml-2 text-sm text-gray-600 font-roboto">Secure & Private</span>
      </div>
      
      <div className="flex items-center mr-6 mb-4">
        <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
          <Check className="h-4 w-4 text-green-500" />
        </div>
        <span className="ml-2 text-sm text-gray-600 font-roboto">ABHA Integrated</span>
      </div>
      
      <div className="flex items-center mb-4">
        <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
          <Check className="h-4 w-4 text-green-500" />
        </div>
        <span className="ml-2 text-sm text-gray-600 font-roboto">2-Minute Setup</span>
      </div>
    </div>
            </div>

            {/* Right column: Image */}
            <div className="w-full lg:w-1/2 relative">
              <div className="rounded-xl overflow-hidden shadow-lg relative z-1 bg-white p-2 transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
                <img
                  src="https://images.unsplash.com/photo-1516841273335-e39b37888115?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w2MzQ2fDB8MXxzZWFyY2h8MXx8aGVhbHRoY2FyZSUyNTIwcHJvZmVzc2lvbmFsJTI1MjB3aXRoJTI1MjBkaWdpdGFsJTI1MjB0YWJsZXQlMjUyMHBhdGllbnQlMjUyMGNvbnN1bHRhdGlvbiUyNTIwbW9kZXJuJTI1MjBtZWRpY2FsJTI1MjBvZmZpY2UlMjUyMG9mZmljZSUyNTIwbGlnaHRpbmclMjUyMHByb2Zlc3Npb25hbCUyNTIwcGhvdG9ncmFwaHklMjUyMHNwYWNlJTI1MjBmb3IlMjUyBHRleHQlMjUyMG92ZXJsYXl8ZW58MHwxfDB8fHx8MTc0NDg3OTQwMHww&ixlib=rb-4.0.3&q=80&w=1080"
                  alt="Healthcare professionals in a hospital hallway with digital technology"
                  className="w-full h-auto rounded-lg"
                  onError={(e) => {
                    e.currentTarget.src = "https://via.placeholder.com/1080x720?text=Image+Not+Found"
                  }}
                />
                <p className="text-xs text-gray-500 absolute bottom-3 right-3 bg-white bg-opacity-75 px-2 py-1 rounded font-roboto">
                  Photo by Luis Melendez
                </p>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#008080]/10 rounded-full opacity-50 z-0 animate-pulse"></div>
              <div
                className="absolute -bottom-10 -left-10 w-40 h-40 bg-green-100 rounded-full opacity-50 z-0 animate-pulse"
                style={{ animationDelay: "1s" }}
              ></div>
            </div>
          </div>
        </div>
      </section>

      <BenefitsTabs />

      {/* ABHA Integration Section */}
      <section className="py-20 bg-gradient-to-br from-green-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            {/* Section Header */}
            <div className="text-center mb-16">
              <span className="inline-block px-5 py-2 bg-gradient-to-r from-[#e6fffa] to-[#b2f5ea] text-[#008080] rounded-full text-sm font-medium font-roboto mb-6 shadow-lg border border-[#99f6e4] hover:shadow-xl hover:-translate-y-0.5 transform transition-all duration-300">
                Digital Health Identity
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#008080] mb-4 font-nunito">
                Create ABHA & Link Your Digital Health Identity
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-[#008080] to-[#00a3a3] mx-auto rounded-full mb-6"></div>
              <p className="text-gray-600 max-w-3xl mx-auto font-roboto">
                Connect your ABHA ID with PatientCare for seamless healthcare services across all providers, ensuring
                your medical history follows you wherever you go.
              </p>
            </div>

            {/* Main content with image and steps */}
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
              {/* Left column with image */}
              <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
                <div className="rounded-xl overflow-hidden shadow-lg border border-gray-100 relative transform transition-all duration-500 hover:shadow-xl hover:-translate-y-1">
                  <img
                    src="https://images.unsplash.com/photo-1516841273335-e39b37888115?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w2MzQ2fDB8MXxzZWFyY2h8MXx8aGVhbHRoY2FyZSUyNTIwZGlnaXRhbCUyNTIwaWRlbnRpdHklMjUyMEFCSEElMjUyMgluZGluZXRpbmclMjUyMHByb2Zlc3Npb25hbCUyNTIwbWluaW1hbGlzdCUyNTIwbW9iaWxlJTI1MjBmcmllbmRseSUyNTIwbWVkaWNhbCUyNTIwbWVkaWNhbCUyNTIwbWFuYWdlbWVudCUyNTIwc2VjdXJlfGVufDN8MHx8fDE3NDQ4Nzk0NTN8MA&ixlib=rb-4.0.3&q=80&w=1080"
                    alt="Healthcare professionals discussing digital health records"
                    className="w-full h-auto object-cover"
                    onError={(e) => {
                      e.currentTarget.src = "https://via.placeholder.com/1080x720?text=Image+Not+Found"
                    }}
                  />
                  <p className="text-xs text-gray-500 absolute bottom-2 right-2 bg-white bg-opacity-75 px-2 py-1 rounded font-roboto">
                    Photo by Luis Melendez
                  </p>
                </div>
              </div>

              {/* Right column with benefits and steps */}
              <div ref={abhaBenefitsRef} className="w-full lg:w-1/2">
                <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg border border-gray-100 transform transition-all duration-300 hover:shadow-xl">
                  <h3 className="text-xl md:text-2xl font-semibold text-[#008080] mb-6 font-nunito">
                    Benefits of ABHA Integration
                  </h3>

                  {/* Benefits list */}
                  <ul className="space-y-4 mb-8">
                    <li className="flex items-start p-3 rounded-lg hover:bg-[#e6fffa]/30 transition-colors duration-300">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[#e6fffa] mt-1 mr-4 flex-shrink-0">
                        <Check className="w-5 h-5 text-[#008080]" />
                      </div>
                      <div>
                        <span className="font-medium text-gray-800 font-roboto">Unified Health Records</span>
                        <p className="text-gray-600 text-sm mt-1 font-roboto">
                          Access your complete medical history from all healthcare providers in one place.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start p-3 rounded-lg hover:bg-[#e6fffa]/30 transition-colors duration-300">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[#e6fffa] mt-1 mr-4 flex-shrink-0">
                        <Check className="w-5 h-5 text-[#008080]" />
                      </div>
                      <div>
                        <span className="font-medium text-gray-800 font-roboto">Enhanced Privacy</span>
                        <p className="text-gray-600 text-sm mt-1 font-roboto">
                          Control who can access your health information with secure consent management.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start p-3 rounded-lg hover:bg-[#e6fffa]/30 transition-colors duration-300">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[#e6fffa] mt-1 mr-4 flex-shrink-0">
                        <Check className="w-5 h-5 text-[#008080]" />
                      </div>
                      <div>
                        <span className="font-medium text-gray-800 font-roboto">Seamless Transfers</span>
                        <p className="text-gray-600 text-sm mt-1 font-roboto">
                          No need to carry physical records when changing doctors or hospitals.
                        </p>
                      </div>
                    </li>
                  </ul>

                  {/* Action buttons */}
                  <div className="flex flex-col sm:flex-row gap-4 mt-8">
                    <button onClick={() => window.open(`${process.env.REACT_APP_CREATE_ABHA_URL}/app/abha`, "_blank")} className="py-3 px-6 bg-[#008080] hover:bg-[#006666] text-white font-medium rounded-lg transition-all duration-300 flex-1 flex items-center justify-center font-roboto shadow-md hover:shadow-lg transform hover:scale-[1.02]">
                      <svg className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                        <path
                          fillRule="evenodd"
                          d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      Create ABHA ID
                    </button>
                    {/* <button className="py-3 px-6 bg-white border border-[#008080] hover:bg-gray-50 text-[#008080] font-medium rounded-lg transition-all duration-300 flex-1 flex items-center justify-center font-roboto shadow-sm hover:shadow-md transform hover:scale-[1.02]">
                <svg className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 12a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"></path>
                  <path
                    fillRule="evenodd"
                    d="M3 8a7 7 0 1114 0 7 7 0 01-14 0zm7-5a5 5 0 100 10 5 5 0 000-10z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                Link Existing ID
              </button> */}
                  </div>

                  {/* Mobile QR Option */}
                  {/* <div className="mt-8 sm:mt-10 flex items-center justify-center border-t border-gray-200 pt-6">
              <div className="text-center">
                <p className="text-sm text-gray-600 mb-3 font-roboto">
                  On mobile? Scan this QR code to create or link your ABHA ID
                </p>
                <div className="inline-block bg-white p-2 border border-gray-200 rounded-lg shadow-sm transform transition-all duration-300 hover:shadow-md hover:scale-105">
                  <div className="w-24 h-24 bg-gray-100 flex items-center justify-center">
                    <svg className="w-20 h-20 text-[#008080]" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M3 3H8V8H3V3Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M16 3H21V8H16V3Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M3 16H8V21H3V16Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M10 3H14V8H10V3Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M3 10H8V14H3V10Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M10 10H14V14H10V10Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M16 10H21V14H16V10Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M10 16H14V21H10V16Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                      <path
                        d="M16 16H21V21H16V16Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <KeyFeatures />
      <FAQTabs />
    </div>
  )
}
